// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-compound-slider {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.react-compound-slider-right-value {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  text-align: right;
  color: var(--black9);
  position: absolute;
  right: -3rem;
  top: -0.25rem;
}
.react-compound-slider-rail {
  position: absolute;
  width: 100%;
  height: 0.5rem;
  border-radius: 6px;
  background-color: var(--black1);
  margin-top: 0;
}
.react-compound-slider .react-compound-slider-handles div span i {
  display: flex;
}
.react-compound-slider-handles div {
  position: absolute;
  z-index: 2;
  border: 2px solid #fff;
  text-align: center;
  cursor: pointer;
  border-radius: 50%;
  color: #333;
  width: 1.5rem;
  height: 1.5rem;
  background: #FFFFFF;
  box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.16), 0px 2px 24px -2px rgba(7, 14, 35, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -0.5rem;
  margin-left: -13px;
}
.react-compound-slider-handles div:hover span {
  display: flex;
}
.react-compound-slider-handles div span {
  background: var(--white);
  padding: 3px 0.5rem 3px;
  display: flex;
  position: absolute;
  top: 29px;
  color: var(--purple6);
  border-radius: 3px;
  font-size: 12px;
  left: 11px;
  transform: translateX(-50%);
  height: 1rem;
  width: 3rem;
  align-items: center;
  justify-content: center;
}
.react-compound-slider-handles div span i {
  display: none;
}
.react-compound-slider-handles div span:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 10px 0 10px;
  border-color: var(--white) rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) rgba(0, 0, 0, 0);
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}
.react-compound-slider-handles div i {
  font-style: normal;
}
.react-compound-slider-tracks div {
  position: absolute;
  height: 8px;
  z-index: 1;
  background-color: #613BEA;
  cursor: pointer;
  border-radius: 0.5rem;
  margin-top: 0;
}
.react-compound-slider-ticks div {
  position: absolute;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 1.5rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: var(--black3);
}
.react-compound-slider-ticks div:after {
  content: "";
  position: absolute;
  height: 0.5rem;
  width: 1px;
  background: var(--black2);
  top: -0.75rem;
  right: 50%;
  transform: translateX(-50%);
}`, "",{"version":3,"sources":["webpack://./client/components/slider/style.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,qBAAA;AACF;AACE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AACJ;AAEE;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,aAAA;AAAJ;AAGE;EACE,aAAA;AADJ;AASE;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EAEA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,yFAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AARJ;AAUI;EACE,aAAA;AARN;AAWI;EACE,wBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AATN;AAWM;EACE,aAAA;AATR;AAYM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,6EAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;AAVR;AAcI;EACE,kBAAA;AAZN;AAgBE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,eAAA;EAEA,qBAAA;EACA,aAAA;AAfJ;AAoBE;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AAnBJ;AAsBI;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;EACA,aAAA;EACA,UAAA;EACA,2BAAA;AApBN","sourcesContent":[".react-compound-slider {\n  padding-left: .5rem;\n  padding-right: .5rem;\n\n  &-right-value {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 13px;\n    line-height: 16px;\n    text-align: right;\n    color: var(--black9);\n    position: absolute;\n    right: -3rem;\n    top: -0.25rem;\n  }\n\n  &-rail {\n    position: absolute;\n    width: 100%;\n    height: .5rem;\n    border-radius: 6px;\n    background-color: var(--black1);\n    margin-top: 0;\n  }\n\n  .react-compound-slider-handles div span i {\n    display: flex;\n  }\n\n  //&:hover {\n  //\n  //}\n\n\n  &-handles div {\n    position: absolute;\n    z-index: 2;\n    border: 2px solid #fff;\n    text-align: center;\n    cursor: pointer;\n    border-radius: 50%;\n    color: #333;\n\n    width: 1.5rem;\n    height: 1.5rem;\n    background: #FFFFFF;\n    box-shadow: 0 2px 4px -1px rgba(7, 14, 35, 0.16), 0px 2px 24px -2px rgba(7, 14, 35, 0.16);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: -.5rem;\n    margin-left: -13px;\n\n    &:hover span {\n      display: flex\n    }\n\n    & span {\n      background: var(--white);\n      padding: 3px .5rem 3px;\n      display: flex;\n      position: absolute;\n      top: 29px;\n      color: var(--purple6);\n      border-radius: 3px;\n      font-size: 12px;\n      left: 11px;\n      transform: translateX(-50%);\n      height: 1rem;\n      width: 3rem;\n      align-items: center;\n      justify-content: center;\n\n      i {\n        display: none;\n      }\n\n      &:before {\n        content: \"\";\n        position: absolute;\n        width: 0;\n        height: 0;\n        border-style: solid;\n        border-width: 10px 10px 0 10px;\n        border-color: var(--white) #0000 #0000 #0000;\n        top: 20px;\n        left: 50%;\n        transform: translateX(-50%);\n      }\n    }\n\n    & i {\n      font-style: normal;\n    }\n  }\n\n  &-tracks div {\n    position: absolute;\n    height: 8px;\n    z-index: 1;\n    background-color: #613BEA;\n    cursor: pointer;\n\n    border-radius: .5rem;\n    margin-top: 0;\n\n\n  }\n\n  &-ticks div {\n    position: absolute;\n    padding-left: 10px;\n    padding-right: 10px;\n\n    margin-top: 1.5rem;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    text-align: center;\n    color: var(--black3);\n\n\n    &:after {\n      content: \"\";\n      position: absolute;\n      height: .5rem;\n      width: 1px;\n      background: var(--black2);\n      top: -0.75rem;\n      right: 50%;\n      transform: translateX(-50%);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
